import $$ep from 'models/ep';
import { Button } from 'react-bootstrap';

import './DocumentsLocation.scss';

import HText from 'components/HText';

import ModalsService from 'services/ModalsService';

import useResources from 'hooks/useResources';

const DocumentsLocation = () => {
    const { t } = useResources();

    const ep = $$ep.stores.$epQInstance.getState();

    if (!ep) {
        return null;
    }

    return ep.location_description?.trim() ? (
        <div className="documents-location-row">
            <div>
                <HText>{t('newDashboardPage.documentsLocation', { location: ep.location_description })}</HText>
            </div>
            <div className="image-wrapper" onClick={() => ModalsService.showModal('SECURE_MODAL')}>
                <Button
                    type="button"
                    variant="link"
                    data-qaid="update_location_button"
                    style={{ padding: 0, minWidth: 0 }}
                >
                    {t('newDashboardPage.documentsLocationEdit')}
                </Button>
            </div>
        </div>
    ) : (
        <></>
    );
};

export default DocumentsLocation;
